import React from 'react'

function SubBanner(props) {
  return (
    <>
    <section className='sub-banner-section'>
      <div className="sub-banner-box">               
        <h2>{props.HeaderTitle}</h2>
      </div>
    </section>
    </>
  )
}
export default SubBanner